import * as UT from "./cyMyManagerUtils";
import * as IF from "./cyMyManagerPlusInterface";
import * as UU from '../classes/uncommonUtility';
import { setBodyReq, getURLServer, getBodyOperator } from "./cyMyManagerPlusUtility";
export { IF };
// import * as Global from "../classes/context";
// import { DeviceEventEmitter } from "react-native";

//#region Altro

// const setBodyReq = (body: any): any => {
//   let globalTmp = Global.initGlobalContextHookless();

//   if (DeviceEventEmitter.listenerCount('main_getContext') > 0)
//     DeviceEventEmitter.emit('main_getContext', globalTmp);

//   if (globalTmp.onPremisesUrl != '')
//     return { "data": body };
//   else
//     return body
// }

// const getURLServer = (): string => {
//   let globalTmp = Global.initGlobalContextHookless();

//   if (DeviceEventEmitter.listenerCount('main_getContext') > 0)
//     DeviceEventEmitter.emit('main_getContext', globalTmp);

//   if (globalTmp.onPremisesUrl != '')
//     return globalTmp.onPremisesUrl + '/api/v1/';
//   else
//     return UT.API_PLUS_URL;
// }

export const getLoginLogo = async (
  authToken: string
): Promise<IF.GetLogoResponse> =>
  fetch(getURLServer() + "GetLoginLogo", UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const GetCalendarAuthURL = async (
  authToken: string,
  cmmAction: string
): Promise<IF.GenericResponseData<string>> =>
  fetch(getURLServer() + "GetCalendarAuthURL?cmmAction=" + cmmAction, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const convertHTMLtoPDF = async (
  authToken: string,
  html: string,
  landscape: number
): Promise<IF.GenericResponseData<string>> => {
  // let encodedAuth = Buffer.from(html, "base64");
  // let encoded = encodedAuth.toString('utf-8');
  // let Buffer = Platform.OS === 'web' ? require('buffer').Buffer : require('buffer/').Buffer
  // let buff = new Buffer(html);
  // html = buff.toString('base64');

  // if (Platform.OS === 'web')
  //   html = Buffer.from('utf-8').toString('base64');
  // else {
  //   let BufferMobile = require('buffer/').Buffer
  //   let buff = new BufferMobile(html);
  //   html = buff.toString('base64');
  // }

  html = UU.convertStringToBase64(html);

  return fetch(getURLServer() + "ConvertHTMLtoPDF", UT.genericPOSTRequest(authToken, setBodyReq({ html, landscape })))
    .then((response) => response.json())
    .then((data) => data);
}

export const get = async (
  authToken: string
): Promise<string> =>
  fetch(getURLServer(), UT.genericGETRequest(authToken))
    .then((response) => response.text())
    .then((data) => data);

export const sincrIntegraz = async (
  authToken: string,
  numPosti: number,
): Promise<IF.GenericResponseData<number>> => {
  let dataSync = { cinebot: { numPosti: numPosti } };
  return fetch(getURLServer() + "SincrIntegraz", UT.genericPOSTRequest(authToken, setBodyReq(dataSync)))
    .then((response) => response.json())
    .then((data) => data);
}

// Questo metodo usa OpenAPI per cui non è possibile chiamarlo onpremises
export const getDatiAziendaDaPIva = async (
  authToken: string,
  piva: string,
): Promise<IF.GenericResponseData<IF.OpenAPIImprese>> => {
  return fetch(UT.API_PLUS_URL + "GetDatiAziendaDaPIva?piva=" + piva, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);
}

//#endregion

//#region Lingue

export const getListLingue = async (
  authToken: string
): Promise<IF.GenericListResponse<IF.Lingua>> =>
  fetch(getURLServer() + "GetListLingue", UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateLingua = async (
  authToken: string,
  lingua: IF.Lingua
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateLingua", UT.genericPOSTRequest(authToken, { lingua }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteLingua = async (
  authToken: string,
  idLingua: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteLingua", UT.genericPOSTRequest(authToken, { idLingua }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region CatalogoLiv1

export const getListaCatalogoLiv1 = async (
  authToken: string,
  idCatalogo: number,
  immagini: number,
  idSedeEserc: number
): Promise<IF.GenericListResponse<IF.CatalogoLiv1>> =>
  fetch(getURLServer() + "GetListCatalogoLiv1?idCatalogo=" + idCatalogo.toString() + '&immagini=' + immagini.toString() + '&idSedeEserc=' + idSedeEserc.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCatalogoLiv1 = async (
  authToken: string,
  catalogoLiv1: IF.CatalogoLiv1
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCatalogoLiv1", UT.genericPOSTRequest(authToken, { catalogoLiv1 }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteCatalogoLiv1 = async (
  authToken: string,
  idCatalogoLiv1: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteCatalogoLiv1", UT.genericPOSTRequest(authToken, { idCatalogoLiv1 }))
    .then((response) => response.json())
    .then((data) => data);

export const getListaCatalogoRicLiv1 = async (
  authToken: string,
  filtro: string,
  idSedeEserc: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.CatalogoRic>> =>
  fetch(getURLServer() + "GetListCatalogoRicLiv1?filtro=" + filtro + '&idSedeEserc=' + idSedeEserc.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region CatalogoLiv2

export const getListaCatalogoLiv2 = async (
  authToken: string,
  catalogoLiv1: number,
  idCatalogo: number,
  immagini: number,
  idSedeEserc: number
): Promise<IF.GenericListResponse<IF.CatalogoLiv2>> =>
  fetch(getURLServer() + "GetListCatalogoLiv2?idCatalogoLiv1=" + catalogoLiv1 + "&idCatalogo=" + idCatalogo.toString() + '&immagini=' + immagini.toString() + '&idSedeEserc=' + idSedeEserc.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCatalogoLiv2 = async (
  authToken: string,
  catalogoLiv2: IF.CatalogoLiv2
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCatalogoLiv2", UT.genericPOSTRequest(authToken, { catalogoLiv2 }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteCatalogoLiv2 = async (
  authToken: string,
  idCatalogoLiv2: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteCatalogoLiv2", UT.genericPOSTRequest(authToken, { idCatalogoLiv2 }))
    .then((response) => response.json())
    .then((data) => data);

export const getListaCatalogoRicLiv2 = async (
  authToken: string,
  filtro: string,
  idSedeEserc: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.CatalogoRic>> =>
  fetch(getURLServer() + "GetListCatalogoRicLiv2?filtro=" + filtro + '&idSedeEserc=' + idSedeEserc.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region CatalogoLiv3

export const getListaCatalogoLiv3 = async (
  authToken: string,
  catalogoLiv2: number,
  idCatalogo: number,
  immagini: number,
  idSedeEserc: number
): Promise<IF.GenericListResponse<IF.CatalogoLiv3>> =>
  fetch(getURLServer() + "GetListCatalogoLiv3?idCatalogoLiv2=" + catalogoLiv2 + "&idCatalogo=" + idCatalogo.toString() + '&immagini=' + immagini.toString() + '&idSedeEserc=' + idSedeEserc.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCatalogoLiv3 = async (
  authToken: string,
  catalogoLiv3: IF.CatalogoLiv3
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCatalogoLiv3", UT.genericPOSTRequest(authToken, { catalogoLiv3 }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteCatalogoLiv3 = async (
  authToken: string,
  idCatalogoLiv3: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteCatalogoLiv3", UT.genericPOSTRequest(authToken, { idCatalogoLiv3 }))
    .then((response) => response.json())
    .then((data) => data);

export const getListaCatalogoRic = async (
  authToken: string,
  filtro: string,
  idSedeEserc: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.CatalogoRic>> =>
  fetch(getURLServer() + "GetListCatalogoRic?filtro=" + filtro + '&pageNumber=' + pageNumber.toString() + '&idSedeEserc=' + idSedeEserc.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Marche

export const getListaMarche = async (
  authToken: string,
  filtro: string,
  idSedeEserc: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.Marca>> =>
  fetch(getURLServer() + "GetListMarche?filtro=" + filtro + '&idSedeEserc=' + idSedeEserc + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateMarca = async (
  authToken: string,
  marca: IF.Marca
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateMarca", UT.genericPOSTRequest(authToken, { marca }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteMarca = async (
  authToken: string,
  idMarca: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteMarca", UT.genericPOSTRequest(authToken, { idMarca }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region FamigliaArticoli

export const getListaFamigliaArticoli = async (
  authToken: string,
  filtro: string,
  idSedeEserc: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.FamigliaArticoli>> =>
  fetch(getURLServer() + "GetListFamigliaArticoli?filtro=" + filtro + '&idSedeEserc=' + idSedeEserc + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateFamigliaArticoli = async (
  authToken: string,
  famigliaArticoli: IF.FamigliaArticoli
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateFamigliaArticoli", UT.genericPOSTRequest(authToken, { famigliaArticoli }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteFamigliaArticoli = async (
  authToken: string,
  idFamigliaArticoli: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteFamigliaArticoli", UT.genericPOSTRequest(authToken, { idFamigliaArticoli }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Codici Iva

export const getListaCodiciIva = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.CodiceIva>> =>
  fetch(getURLServer() + "GetListCodiciIva?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCodiceIva = async (
  authToken: string,
  codiceIva: IF.CodiceIva
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCodiceIva", UT.genericPOSTRequest(authToken, { codiceIva }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteCodiceIva = async (
  authToken: string,
  idCodiceIva: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteCodiceIva", UT.genericPOSTRequest(authToken, { idCodiceIva }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Unità Di Misura

export const getListaUnitaDiMisura = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.UnitaDiMisura>> =>
  fetch(getURLServer() + "GetListUnitaDiMisura?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateUnitaDiMisura = async (
  authToken: string,
  unitaDiMisura: IF.UnitaDiMisura
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateUnitaDiMisura", UT.genericPOSTRequest(authToken, { unitaDiMisura }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteUnitaDiMisura = async (
  authToken: string,
  idUnitaDiMisura: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteUnitaDiMisura", UT.genericPOSTRequest(authToken, { idUnitaDiMisura }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Articoli

export const getArticolo = async (
  authToken: string,
  idArticolo: number,
): Promise<IF.GenericListResponse<IF.Articolo>> =>
  fetch(getURLServer() + "GetArticolo?idArticolo=" + idArticolo.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

// soloArtVarianti: 0 - normali o capovarianti, 1 - normali o varianti, 2 - solo varianti
export const getListaArticoli = async (
  authToken: string,
  filtroDes: string,
  filtroCatL1: number,
  filtroCatL2: number,
  filtroCatL3: number,
  filtroMarca: number,
  filtroFamiglia: number,
  soloArtVarianti: 0 | 1 | 2,
  ordinamento: 0 | 1 | 2 | 3,
  idSedeEserc: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.Articolo>> =>
  fetch(getURLServer() + "GetListArticoli?filtroDes=" + filtroDes + '&filtroCatL1=' + filtroCatL1.toString() + '&filtroCatL2=' + filtroCatL2.toString() + '&filtroCatL3=' + filtroCatL3.toString() + '&filtroMarca=' + filtroMarca.toString() + '&filtroFamiglia=' + filtroFamiglia.toString() + '&soloArtVarianti=' + soloArtVarianti.toString() + '&ordinamento=' + ordinamento.toString() + '&idSedeEserc=' + idSedeEserc.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateArticolo = async (
  authToken: string,
  articolo: IF.Articolo
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateArticolo", UT.genericPOSTRequest(authToken, { articolo }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteArticolo = async (
  authToken: string,
  idArticolo: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteArticolo", UT.genericPOSTRequest(authToken, { idArticolo }))
    .then((response) => response.json())
    .then((data) => data);

export const getVariantiArticolo = async (
  authToken: string,
  idArticolo: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.Articolo>> =>
  fetch(getURLServer() + "GetVariantiArticolo?idArticolo=" + idArticolo.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const rigeneraVariantiArticolo = async (
  authToken: string,
  idArticolo: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "RigeneraVariantiArticolo", UT.genericPOSTRequest(authToken, { idArticolo }))
    .then((response) => response.json())
    .then((data) => data);

export const getArticoliMaxVendita = async (
  authToken: string,
  idArticolo: number,
): Promise<IF.GenericListResponse<IF.ArticoliMaxVendita>> =>
  fetch(getURLServer() + "GetArticoliMaxVendita?idArticolo=" + idArticolo.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getArticoloVendValid = async (
  authToken: string,
  idArticolo: number,
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "GetArticoloVendValid?idArticolo=" + idArticolo.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Tipologie varianti articoli

export const getListTipiVariantiArt = async (
  authToken: string,
  filtro: string,
  idTipVar: number,
): Promise<IF.GenericListResponse<IF.TipoVarianteArticolo>> =>
  fetch(getURLServer() + "GetListTipiVariantiArt?filtro=" + filtro + "&idTipVar=" + idTipVar.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateTipoVarianteArt = async (
  authToken: string,
  tipoVariante: IF.TipoVarianteArticolo
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateTipoVarianteArt", UT.genericPOSTRequest(authToken, { tipoVariante }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteTipoVarianteArt = async (
  authToken: string,
  idTipVar: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteTipoVarianteArt", UT.genericPOSTRequest(authToken, { idTipVar }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Varianti articoli

export const getListVariantiArt = async (
  authToken: string,
  filtro: string,
  idArticolo: number,
): Promise<IF.GenericListResponse<IF.VarianteArticolo>> =>
  fetch(getURLServer() + "GetListVariantiArt?filtro=" + filtro + "&idArticolo=" + idArticolo.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateVarianteArt = async (
  authToken: string,
  varianteArt: IF.VarianteArticolo
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateVarianteArt", UT.genericPOSTRequest(authToken, { varianteArt }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteVarianteArt = async (
  authToken: string,
  idArticolo: number,
  idVariante: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteVarianteArt", UT.genericPOSTRequest(authToken, setBodyReq({ idArticolo, idVariante })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Kit articoli

export const getListaKitArticoli = async (
  authToken: string,
  filtroDes: string,
  idArticolo: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.ArticoliKitElemento>> =>
  fetch(getURLServer() + "GetListKitArticoli?filtroDes=" + filtroDes + '&idArticolo=' + idArticolo.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateKitArticolo = async (
  authToken: string,
  kitArticolo: IF.ArticoliKitElemento
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateKitArticolo", UT.genericPOSTRequest(authToken, { kitArticolo }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteKitArticolo = async (
  authToken: string,
  idArtPrincipale: number,
  idArtComponente: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteKitArticolo", UT.genericPOSTRequest(authToken, setBodyReq({ idArtPrincipale, idArtComponente })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Immagini

export const getListaImmagini = async (
  authToken: string,
  idArticolo: number,
): Promise<IF.GenericListResponse<IF.ArticoloImg>> =>
  fetch(getURLServer() + "GetListImmagini?idArticolo=" + idArticolo, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateImmagine = async (
  authToken: string,
  immagine: IF.ArticoloImg
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateImmagine", UT.genericPOSTRequest(authToken, { immagine }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteImmagine = async (
  authToken: string,
  idArticolo: number,
  idImg: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteImmagine", UT.genericPOSTRequest(authToken, setBodyReq({ idArticolo, idImg })))
    .then((response) => response.json())
    .then((data) => data);

export const switchImmagine = async (
  authToken: string,
  idArticolo: number,
  idImg: number,
  idImg2: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "SwitchImmagine", UT.genericPOSTRequest(authToken, setBodyReq({ idArticolo, idImg, idImg2 })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Attributi

export const getListaAttributi = async (
  authToken: string
): Promise<IF.GenericListResponse<IF.Attributo>> =>
  fetch(getURLServer() + "GetListAttributi", UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateAttributo = async (
  authToken: string,
  attributo: IF.Attributo
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateAttributo", UT.genericPOSTRequest(authToken, { attributo }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteAttributo = async (
  authToken: string,
  idAttributo: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteAttributo", UT.genericPOSTRequest(authToken, { idAttributo }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region AttributiProp

export const getListaAttributiProps = async (
  authToken: string,
  idAttributo: number
): Promise<IF.GenericListResponse<IF.AttributoProp>> =>
  fetch(getURLServer() + "GetListAttributiProp?idAttributo=" + idAttributo, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateAttributoProp = async (
  authToken: string,
  attributoProp: IF.AttributoProp
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateAttributoProp", UT.genericPOSTRequest(authToken, { attributoProp }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteAttributoProp = async (
  authToken: string,
  idAttributo: number,
  progressivo: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteAttributoProp", UT.genericPOSTRequest(authToken, setBodyReq({ idAttributo, progressivo })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Menu combo

export const getListaMenuCombo = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.MenuCombo>> =>
  fetch(getURLServer() + "GetListMenuCombo?filtro=" + filtro + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateMenuCombo = async (
  authToken: string,
  menuCombo: IF.MenuCombo
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateMenuCombo", UT.genericPOSTRequest(authToken, { menuCombo }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteMenuCombo = async (
  authToken: string,
  idMenu: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteMenuCombo", UT.genericPOSTRequest(authToken, { idMenu }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Fasce orarie generiche

export const getListaFasceOrarieGeneriche = async (
  authToken: string,
  filtro: string,
  idSedeEserc: number,
  pageNumber: number,
  itemsPerPage: number,
  idFascia: number,
): Promise<IF.GenericListResponse<IF.FasciaOrariaGenerica>> =>
  fetch(getURLServer() + "GetListFasceOrarieGeneriche?filtro=" + filtro + '&idSedeEserc=' + idSedeEserc + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&idFascia=' + idFascia, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateFasciaOrariaGenerica = async (
  authToken: string,
  fasciaOrariaGen: IF.FasciaOrariaGenerica
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateFasciaOrariaGenerica", UT.genericPOSTRequest(authToken, { fasciaOrariaGen }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteFasciaOrariaGenerica = async (
  authToken: string,
  idFascia: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteFasciaOrariaGenerica", UT.genericPOSTRequest(authToken, { idFascia }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Abbonamenti

export const getListaAbbonamentiFull = async (
  authToken: string,
  filtroDes: string,
  idArticolo: number,
  tipoAbbonamento: number,
  durata: number,
  pageNumber: number,
  itemsPerPage: number,
  tipoRiga: IF.TipoRigaAbb | -1,
  idPrestazione: number,
  idAbbonamento: number,
  idSedeEserc: number,
): Promise<IF.GenericListResponse<IF.Abbonamento>> =>
  fetch(getURLServer() + "GetListAbbonamentiFull?filtroDes=" + filtroDes + '&idArticolo=' + idArticolo.toString() + '&tipoAbbonamento=' + tipoAbbonamento.toString() + '&durata=' + durata.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString() + '&tipoRiga=' + tipoRiga.toString() + '&idPrestazione=' + idPrestazione.toString() + '&idAbbonamento=' + idAbbonamento.toString() + '&idSedeEserc=' + idSedeEserc.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateAbbonamento = async (
  authToken: string,
  abbonamento: IF.Abbonamento
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateAbbonamento", UT.genericPOSTRequest(authToken, { abbonamento }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteAbbonamento = async (
  authToken: string,
  idAbbonamento: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteAbbonamento", UT.genericPOSTRequest(authToken, { idAbbonamento }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Clienti

export const getCliente = async (
  authToken: string,
  idCliente: number,
): Promise<IF.GenericResponseData<IF.Cliente>> =>
  fetch(getURLServer() + "GetCliente?idCliente=" + idCliente.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getListClienti = async (
  authToken: string,
  tipoAnag: IF.TipoAnagCliFor | -1,
  filtro: string,
  ordinamento: 0 | 1 | 2 | 3,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.Cliente>> =>
  fetch(getURLServer() + "GetListClienti?tipoAnag=" + tipoAnag + "&filtro=" + filtro + '&ordinamento=' + ordinamento.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCliente = async (
  authToken: string,
  cliente: IF.Cliente
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "UpdateCliente", UT.genericPOSTRequest(authToken, { cliente }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteCliente = async (
  authToken: string,
  idCliente: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteCliente", UT.genericPOSTRequest(authToken, { idCliente }))
    .then((response) => response.json())
    .then((data) => data);

export const purgeCliente = async (
  authToken: string,
  idCliente: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "PurgeCliente", UT.genericPOSTRequest(authToken, { idCliente }))
    .then((response) => response.json())
    .then((data) => data);

export const inviaCodiceFirmaCliente = async (
  authToken: string,
  cliente: IF.Cliente,
  tipoInvio: IF.TipoInvioMsg,
): Promise<IF.GenericResponseData<string>> => {
  let result: IF.GenericResponseData<string> = IF.GenericResponseDataInit('');

  let icfc = await fetch(getURLServer() + "InviaCodiceFirmaCliente", UT.genericPOSTRequest(authToken, setBodyReq({ cliente, tipoInvio })));
  let icfcres: IF.GenericResponseData<IF.SmsOtp> = await icfc.json();

  result.isOk = icfcres.isOk;
  result.msgErr = icfcres.msgErr;
  result.data = icfcres.data.code;

  if (icfcres.isOk && tipoInvio === IF.TipoInvioMsg.SMS) {
    let ssmsm = await fetch(UT.API_URL + "SendSMSMessage?number=" + icfcres.data.number + "&message=" + icfcres.data.message, UT.genericGETRequest(authToken));
    let ssmsmres = await ssmsm.json() as { okResult: boolean; msgErr: string };
    result.isOk = ssmsmres.okResult;
    result.msgErr = ssmsmres.msgErr;
  }

  return result;
}

export const loginCliente = async (
  authToken: string,
  username: string,
  password: string
): Promise<IF.GenericResponseData<IF.Cliente>> =>
  fetch(getURLServer() + "LoginCliente", UT.genericPOSTRequest(authToken, { username, password }))
    .then((response) => response.json())
    .then((data) => data);

export const getOTPCodeRecuperaPwd = async (
  authToken: string,
  email: string,
): Promise<IF.GenericListResponse<IF.Cliente>> =>
  fetch(getURLServer() + "GetOTPCodeRecuperaPwd?email=" + email, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getClienteByEmail = async (
  authToken: string,
  email: string,
): Promise<IF.GenericListResponse<IF.Cliente>> =>
  fetch(getURLServer() + "GetClienteByEmail?email=" + email, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const validateOTPCode = async (
  authToken: string,
  OTPCode: string
): Promise<IF.GenericResponseData<string>> =>
  fetch(getURLServer() + "ValidateOTPCode", UT.genericPOSTRequest(authToken, { OTPCode }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Attributi clienti

export const getListaAttributiClienti = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.AttributoClienti>> =>
  fetch(getURLServer() + "GetListAttributiClienti?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateAttributoCliente = async (
  authToken: string,
  attrCliente: IF.AttributoClienti
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateAttributoCliente", UT.genericPOSTRequest(authToken, { attrCliente }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteAttributoCliente = async (
  authToken: string,
  idAttrCliente: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteAttributoCliente", UT.genericPOSTRequest(authToken, { idAttrCliente }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Indirizzi

export const getListIndirizzi = async (
  authToken: string,
  idCliente: number,
  soloPrincipale: boolean
): Promise<IF.GenericListResponse<IF.Indirizzo>> =>
  fetch(getURLServer() + "GetListIndirizzi?idCliente=" + idCliente + '&soloPrincipale=' + soloPrincipale, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateIndirizzo = async (
  authToken: string,
  indirizzo: IF.Indirizzo
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "UpdateIndirizzo", UT.genericPOSTRequest(authToken, { indirizzo }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteIndirizzo = async (
  authToken: string,
  idIndirizzo: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteIndirizzo", UT.genericPOSTRequest(authToken, { idIndirizzo }))
    .then((response) => response.json())
    .then((data) => data);

export const getListaComuni = async (
  authToken: string,
  filtro: string,
  conStati: number,
  conLatLon: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.Comune>> =>
  fetch(getURLServer() + "GetListComuni?filtro=" + filtro + '&conStati=' + conStati.toString() + '&conLatLon=' + conLatLon.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getListaStati = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.Stato>> =>
  fetch(getURLServer() + "GetListStati?filtro=" + filtro + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region AllegatiCli

export const getListaAllegatiCli = async (
  authToken: string,
  idCliente: number,
): Promise<IF.GenericListResponse<IF.AllegatoCliente>> =>
  fetch(getURLServer() + "GetListAllegatiCli?idCliente=" + idCliente, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateAllegatoCli = async (
  authToken: string,
  allegato: IF.AllegatoCliente
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateAllegatoCli", UT.genericPOSTRequest(authToken, { allegato }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteAllegatoCli = async (
  authToken: string,
  idCliente: number,
  idAllegato: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteAllegatoCli", UT.genericPOSTRequest(authToken, setBodyReq({ idCliente, idAllegato })))
    .then((response) => response.json())
    .then((data) => data);

export const switchAllegatoCli = async (
  authToken: string,
  idCliente: number,
  idAllegato: number,
  idAllegato2: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "SwitchAllegatoCli", UT.genericPOSTRequest(authToken, setBodyReq({ idCliente, idAllegato, idAllegato2 })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Indirizzi Spedizioni

export const getListIndirizziSpediz = async (
  authToken: string,
  idCliente: number,
  soloPrincipale: boolean
): Promise<IF.GenericListResponse<IF.IndirizzoSpediz>> =>
  fetch(getURLServer() + "GetListIndirizziSpediz?idCliente=" + idCliente + '&soloPrincipale=' + soloPrincipale, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateIndirizzoSpediz = async (
  authToken: string,
  indirSpediz: IF.IndirizzoSpediz
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "UpdateIndirizzoSpediz", UT.genericPOSTRequest(authToken, { indirSpediz }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteIndirizzoSpediz = async (
  authToken: string,
  idCliente: number,
  progressivo: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteIndirizzoSpediz", UT.genericPOSTRequest(authToken, { idCliente, progressivo }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Tipologie schede clienti

export const getListTipologieSchede = async (
  authToken: string,
  filtro: string,
  idTipoScheda: number,
): Promise<IF.GenericListResponse<IF.TipologiaSchedaTes>> =>
  fetch(getURLServer() + "GetListTipologieSchede?filtro=" + filtro + "&idTipoScheda=" + idTipoScheda.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateTipologiaScheda = async (
  authToken: string,
  tipologiaScheda: IF.TipologiaSchedaTes,
  soloTemplate: boolean
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateTipologiaScheda", UT.genericPOSTRequest(authToken, setBodyReq({ tipologiaScheda, soloTemplate })))
    .then((response) => response.json())
    .then((data) => data);

export const deleteTipologiaScheda = async (
  authToken: string,
  idTipologiaScheda: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteTipologiaScheda", UT.genericPOSTRequest(authToken, { idTipologiaScheda }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Modelli schede clienti

export const getListTipSchedeModelli = async (
  authToken: string,
  filtro: string,
  idTesTipSch: number,
  idRigTipSch: number
): Promise<IF.GenericListResponse<IF.TipologiaSchedaRigModelli>> =>
  fetch(getURLServer() + "GetListTipSchedeModelli?filtro=" + filtro + "&idTesTipSch=" + idTesTipSch.toString() + "&idRigTipSch=" + idRigTipSch.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateTipSchedeModelli = async (
  authToken: string,
  modello: IF.TipologiaSchedaRigModelli,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateTipSchedeModelli", UT.genericPOSTRequest(authToken, { modello }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteTipSchedeModelli = async (
  authToken: string,
  idModello: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteTipSchedeModelli", UT.genericPOSTRequest(authToken, { idModello }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Schede clienti

export const getListSchedeClienti = async (
  authToken: string,
  filtro: string,
  filtroDataDa: string,
  filtroDataA: string,
  idCliente: number,
  numScheda: number,
  idTipScheda: number,
  ordinamento: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.SchedaCliente>> =>
  fetch(getURLServer() + "GetListSchedeClienti?filtro=" + filtro + "&filtroDataDa=" + filtroDataDa + "&filtroDataA=" + filtroDataA + "&idCliente=" + idCliente.toString() + "&numScheda=" + numScheda.toString() + "&idTipScheda=" + idTipScheda.toString() + "&ordinamento=" + ordinamento.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateSchedaCliente = async (
  authToken: string,
  schedaCliente: IF.SchedaCliente
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "UpdateSchedaCliente", UT.genericPOSTRequest(authToken, { schedaCliente }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteSchedaCliente = async (
  authToken: string,
  idCliente: number,
  numScheda: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteSchedaCliente", UT.genericPOSTRequest(authToken, setBodyReq({ idCliente, numScheda })))
    .then((response) => response.json())
    .then((data) => data);

export const getDefaultTemplateSchedaCli = async (
  authToken: string,
): Promise<IF.GenericResponseData<string>> =>
  fetch(getURLServer() + "GetDefaultTemplateSchedaCli", UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getPDFSchedaCliente = async (
  authToken: string,
  idCliente: number,
  numScheda: number,
): Promise<IF.GenericResponseData<string>> =>
  fetch(getURLServer() + "GetPDFSchedaCliente?idCliente=" + idCliente.toString() + "&numScheda=" + numScheda.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const postPDFSchedaClienteAntepr = async (
  authToken: string,
  schedaCliente: IF.SchedaCliente
): Promise<IF.GenericResponseData<string>> =>
  fetch(getURLServer() + "PostPDFSchedaClienteAntepr", UT.genericPOSTRequest(authToken, { schedaCliente }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Promozioni

export const getListaPromozioni = async (
  authToken: string,
  idSedeEserc: number
): Promise<IF.GenericListResponse<IF.Promozione>> =>
  fetch(getURLServer() + "GetListPromozioni?idSedeEserc=" + idSedeEserc.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updatePromozione = async (
  authToken: string,
  promozione: IF.Promozione
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdatePromozione", UT.genericPOSTRequest(authToken, { promozione }))
    .then((response) => response.json())
    .then((data) => data);

export const deletePromozione = async (
  authToken: string,
  idPromozione: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeletePromozione", UT.genericPOSTRequest(authToken, { idPromozione }))
    .then((response) => response.json())
    .then((data) => data);

export const getPromozionePerArticolo = async (
  authToken: string,
  idArticolo: number,
  dataCheck: string,
): Promise<IF.GenericListResponse<IF.Promozione>> =>
  fetch(getURLServer() + "GetPromozionePerArticolo?idArticolo=" + idArticolo.toString() + '&dataCheck=' + dataCheck, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getPromozionePerAbbonamento = async (
  authToken: string,
  idAbbonamento: number,
  dataCheck: string,
): Promise<IF.GenericListResponse<IF.Promozione>> =>
  fetch(getURLServer() + "GetPromozionePerAbbonamento?idAbbonamento=" + idAbbonamento.toString() + '&dataCheck=' + dataCheck, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getPromozionePerMenuCombo = async (
  authToken: string,
  idMenu: number,
  dataCheck: string,
): Promise<IF.GenericListResponse<IF.Promozione>> =>
  fetch(getURLServer() + "GetPromozionePerMenuCombo?idMenu=" + idMenu.toString() + '&dataCheck=' + dataCheck, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Spedizioni

export const getListaSpedizioni = async (
  authToken: string,
  filtro: string,
  idSedeEserc: number,
): Promise<IF.GenericListResponse<IF.Spedizione>> =>
  fetch(getURLServer() + "GetListSpedizioni?filtro=" + filtro + '&idSedeEserc=' + idSedeEserc, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateSpedizione = async (
  authToken: string,
  spedizione: IF.Spedizione
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateSpedizione", UT.genericPOSTRequest(authToken, { spedizione }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteSpedizione = async (
  authToken: string,
  idSpedizione: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteSpedizione", UT.genericPOSTRequest(authToken, { idSpedizione }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Carrello

export const getListaCarrello = async (
  authToken: string,
  idCliente: number,
): Promise<IF.GenericListResponse<IF.CarrelloItem>> =>
  fetch(getURLServer() + "GetListCarrello?idCliente=" + idCliente, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCarrello = async (
  authToken: string,
  carrelloItem: IF.CarrelloItem
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCarrello", UT.genericPOSTRequest(authToken, { carrelloItem }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteCarrello = async (
  authToken: string,
  idCliente: number,
  tipoRiga: IF.TipoRigaCarr,
  codice: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteCarrello", UT.genericPOSTRequest(authToken, setBodyReq({ idCliente, tipoRiga, codice })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Template stampe documenti

export const getListaTemplateStampeDoc = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
  idTemplate: number,
): Promise<IF.GenericListResponse<IF.TemplateStampaDoc>> =>
  fetch(getURLServer() + "GetListTemplateStampeDoc?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&idTemplate=' + idTemplate, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateTemplateStampaDoc = async (
  authToken: string,
  template: IF.TemplateStampaDoc
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateTemplateStampaDoc", UT.genericPOSTRequest(authToken, { template }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteTemplateStampaDoc = async (
  authToken: string,
  idTemplate: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteTemplateStampaDoc", UT.genericPOSTRequest(authToken, { idTemplate }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Ordini

export const getOrdine = async (
  authToken: string,
  idOrdine: number,
): Promise<IF.GenericResponseData<IF.Ordine>> =>
  fetch(getURLServer() + "GetOrdine?idOrdine=" + idOrdine, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getListaOrdini = async (
  authToken: string,
  tipoDoc: IF.TipoDocumento | -1,
  idSedeEserc: number,
  idCliente: number,
  filtroDataDa: string,
  filtroDataA: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.OrdineTestata>> =>
  fetch(getURLServer() + "GetListOrdini?tipoDoc=" + tipoDoc + '&idSedeEserc=' + idSedeEserc + '&idCliente=' + idCliente + '&filtroDataDa=' + filtroDataDa + '&filtroDataA=' + filtroDataA + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getListaOrdineRighe = async (
  authToken: string,
  idOrdine: number,
): Promise<IF.GenericListResponse<IF.OrdineRiga>> =>
  fetch(getURLServer() + "GetListOrdineRighe?idOrdine=" + idOrdine, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateOrdine = async (
  authToken: string,
  ordine: IF.Ordine
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "UpdateOrdine", UT.genericPOSTRequest(authToken, { ordine }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteOrdine = async (
  authToken: string,
  idOrdine: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteOrdine", UT.genericPOSTRequest(authToken, { idOrdine }))
    .then((response) => response.json())
    .then((data) => data);

export const getListaOrdiniExport = async (
  authToken: string,
  tipoDoc: IF.TipoDocumento | -1,
  idSedeEserc: number,
  idCliente: number,
  filtroDataDa: string,
  filtroDataA: string,
): Promise<IF.GenericListResponse<IF.OrdineTestata>> =>
  fetch(getURLServer() + "GetListOrdiniExport?tipoDoc=" + tipoDoc + "&idSedeEserc=" + idSedeEserc + '&idCliente=' + idCliente + '&filtroDataDa=' + filtroDataDa + '&filtroDataA=' + filtroDataA, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getPDFOrdine = async (
  authToken: string,
  idOrdine: number,
): Promise<IF.GenericResponseData<string>> =>
  fetch(getURLServer() + "GetPDFOrdine?idOrdine=" + idOrdine.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Abbonamenti Venduti

export const getListaAbbonamVend = async (
  authToken: string,
  idCliente: number,
  filtroDataDa: string,
  filtroDataA: string,
  filtroDScaDa: string,
  filtroDScaA: string,
  idAbbonamento: number,
  idPrestazione: number,
  idArticolo: number,
  idSedeEserc: number,
  transazione: string,
  pageNumber: number,
  itemsPerPage: number,
  idAbbVen: number,
): Promise<IF.GenericListResponse<IF.AbbonamVendTest>> =>
  fetch(getURLServer() + "GetListAbbonamVend?idCliente=" + idCliente + '&filtroDataDa=' + filtroDataDa + '&filtroDataA=' + filtroDataA + '&filtroDScaDa=' + filtroDScaDa + '&filtroDScaA=' + filtroDScaA + '&idAbbonamento=' + idAbbonamento + '&idPrestazione=' + idPrestazione + '&idArticolo=' + idArticolo + '&idSedeEserc=' + idSedeEserc + '&transazione=' + transazione + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&idAbbVen=' + idAbbVen, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getAbbonamVendRighe = async (
  authToken: string,
  idAbbVen: number,
): Promise<IF.GenericListResponse<IF.AbbonamVendRiga>> =>
  fetch(getURLServer() + "GetAbbonamVendRighe?idAbbVen=" + idAbbVen, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateAbbonamVend = async (
  authToken: string,
  abbVen: IF.AbbonamVend
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "UpdateAbbonamVend", UT.genericPOSTRequest(authToken, { abbVen }))
    .then((response) => response.json())
    .then((data) => data);

export const sospendiAbbonamVend = async (
  authToken: string,
  idAbbVen: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "SospendiAbbonamVend", UT.genericPOSTRequest(authToken, { idAbbVen }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteAbbonamVend = async (
  authToken: string,
  idAbbVen: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteAbbonamVend", UT.genericPOSTRequest(authToken, { idAbbVen }))
    .then((response) => response.json())
    .then((data) => data);

export const insAbbonamVendWeb = async (
  authToken: string,
  idAbb: number,
  idCliente: number,
  idSedeEserc: number,
  transaz: string
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "InsAbbonamVendWeb", UT.genericPOSTRequest(authToken, setBodyReq({ idAbb, idCliente, idSedeEserc, transaz })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Movimenti magazzino

export const getListaMovMagazzino = async (
  authToken: string,
  filtroDataDa: string,
  filtroDataA: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.MovMagazzinoTestata>> =>
  fetch(getURLServer() + "GetListMovMagazzino?filtroDataDa=" + filtroDataDa + '&filtroDataA=' + filtroDataA + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getListaMovMagazzinoRighe = async (
  authToken: string,
  idMovMagazzino: number,
): Promise<IF.GenericListResponse<IF.MovMagazzinoRiga>> =>
  fetch(getURLServer() + "GetListMovMagazzinoRighe?idMovMagazzino=" + idMovMagazzino, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateMovMagazzino = async (
  authToken: string,
  movMagazzino: IF.MovMagazzino
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateMovMagazzino", UT.genericPOSTRequest(authToken, { movMagazzino }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteMovMagazzino = async (
  authToken: string,
  idMovMagazzino: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteMovMagazzino", UT.genericPOSTRequest(authToken, { idMovMagazzino }))
    .then((response) => response.json())
    .then((data) => data);

export const getListaMovMagazzinoExport = async (
  authToken: string,
  filtroDataDa: string,
  filtroDataA: string,
): Promise<IF.GenericListResponse<IF.MovMagazzinoTestata>> =>
  fetch(getURLServer() + "GetListMovMagazzinoExport?filtroDataDa=" + filtroDataDa + '&filtroDataA=' + filtroDataA, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getArtPerScansioneMag = async (
  authToken: string,
  codiceScan: string,
): Promise<IF.GenericResponseData<IF.Articolo>> =>
  fetch(getURLServer() + "GetArtPerScansioneMag?codiceScan=" + codiceScan, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Gruppi

export const getListGruppi = async (
  authToken: string
): Promise<IF.GenericListResponse<IF.Gruppo>> =>
  fetch(getURLServer() + "GetListGruppi", UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateGruppo = async (
  authToken: string,
  gruppo: IF.Gruppo
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateGruppo", UT.genericPOSTRequest(authToken, { gruppo }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteGruppo = async (
  authToken: string,
  idGruppo: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteGruppo", UT.genericPOSTRequest(authToken, { idGruppo }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Operatori

export const getListOperatori = async (
  authToken: string,
  idGruppo: number,
  idOperatore: number,
  getCalendGoogle: number
): Promise<IF.GenericListResponse<IF.Operatore>> =>
  fetch(getURLServer() + "GetListOperatori?idGruppo=" + idGruppo.toString() + '&idOperatore=' + idOperatore.toString() + '&getCalendGoogle=' + getCalendGoogle.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateOperatore = async (
  authToken: string,
  operatore: IF.Operatore
): Promise<IF.GenericResponse> => {
  let body: any = { operatore };

  body = getBodyOperator(body, operatore);

  return fetch(getURLServer() + "UpdateOperatore", UT.genericPOSTRequest(authToken, body))
    .then((response) => response.json())
    .then((data) => data);
}

export const deleteOperatore = async (
  authToken: string,
  idOperatore: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteOperatore", UT.genericPOSTRequest(authToken, { idOperatore }))
    .then((response) => response.json())
    .then((data) => data);

export const loginOperatore = async (
  authToken: string,
  username: string,
  password: string
): Promise<{ okResult: boolean; operatore: IF.Operatore }> =>
  fetch(getURLServer() + "LoginOperatore", UT.genericPOSTRequest(authToken, setBodyReq({ username, password })))
    .then((response) => response.json())
    .then((data) => data);

export const cambiaPwdOper = async (
  authToken: string,
  username: string,
  oldPwd: string,
  newPwd: string
): Promise<{ okResult: boolean; operatore: IF.Operatore }> =>
  fetch(getURLServer() + "CambiaPwdOper", UT.genericPOSTRequest(authToken, setBodyReq({ username, oldPwd, newPwd })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Presenze operatori

export const getListPresenzeOper = async (
  authToken: string,
  idOperatore: number,
  filtroDataDa: string,
  filtroDataA: string,
  perExport: number,
  pageNumber: number,
  itemsPerPage: number
): Promise<IF.GenericListResponse<IF.PresenzaOperatore>> =>
  fetch(getURLServer() + "GetListPresenzeOper?idOperatore=" + idOperatore.toString() + '&filtroDataDa=' + filtroDataDa + '&filtroDataA=' + filtroDataA + '&perExport=' + perExport.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updatePresenzaOper = async (
  authToken: string,
  presenzaOper: IF.PresenzaOperatore
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdatePresenzaOper", UT.genericPOSTRequest(authToken, { presenzaOper }))
    .then((response) => response.json())
    .then((data) => data);

export const deletePresenzaOper = async (
  authToken: string,
  idPresOper: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeletePresenzaOper", UT.genericPOSTRequest(authToken, { idPresOper }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Prenotazioni

export const getListPrenotazioni = async (
  authToken: string,
  dataPren: string,
  idCliente: number,
  idArticolo: number
): Promise<IF.GenericListResponse<IF.Prenotazione>> =>
  fetch(getURLServer() + "GetListPrenotazioni?dataPren=" + dataPren + "&idCliente=" + idCliente.toString() + "&idArticolo=" + idArticolo.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updatePrenotazione = async (
  authToken: string,
  prenotazione: IF.Prenotazione,
  qtaGestFascia: number,
  idSedeEserc: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdatePrenotazione", UT.genericPOSTRequest(authToken, setBodyReq({ prenotazione, qtaGestFascia, idSedeEserc })))
    .then((response) => response.json())
    .then((data) => data);

export const updatePrenotazioneDesk = async (
  authToken: string,
  prenotazione: IF.Prenotazione,
  qtaGestFascia: number,
  saltaControlli: boolean,
  idAbbVendCont: number,
  idSedeEserc: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdatePrenotazioneDesk", UT.genericPOSTRequest(authToken, setBodyReq({ prenotazione, qtaGestFascia, saltaControlli, idAbbVendCont, idSedeEserc })))
    .then((response) => response.json())
    .then((data) => data);

export const deletePrenotazione = async (
  authToken: string,
  idPrenotazione: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeletePrenotazione", UT.genericPOSTRequest(authToken, { idPrenotazione }))
    .then((response) => response.json())
    .then((data) => data);

export const getArtPrenCli = async (
  authToken: string,
  idCliente: number,
  withFasce: boolean,
  idSedeEserc: number,
): Promise<IF.GenericListResponse<IF.ArtPrenPerCli>> =>
  fetch(getURLServer() + "GetArtPrenotabiliPerCliente?idCliente=" + idCliente.toString() + "&withFasce=" + withFasce + "&idSedeEserc=" + idSedeEserc.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getArtFasceOrarie = async (
  authToken: string,
  idArticolo: number,
): Promise<IF.GenericListResponse<IF.FasciaOraria>> =>
  fetch(getURLServer() + "GetArtFasceOrarie?idArticolo=" + idArticolo.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getOTPCodePrenotazione = async (
  authToken: string,
  idPrenotazione: number,
  idSedeEserc: number,
): Promise<IF.OTPPrenoResponse> =>
  fetch(getURLServer() + "GetOTPCodePrenotazione?idPrenotazione=" + idPrenotazione.toString() + '&idSedeEserc=' + idSedeEserc.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getDatiPrenotazione = async (
  authToken: string,
  OTPCodePrenotaz: string,
  idSedeEserc: number,
): Promise<IF.GenericListResponse<IF.Prenotazione & { idAbbVend: number; }>> =>
  fetch(getURLServer() + "GetDatiPrenotazione?OTPCodePrenotaz=" + OTPCodePrenotaz + '&idSedeEserc=' + idSedeEserc, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getResiduoPostoPrenotazione = async (
  authToken: string,
  dataPren: string,
  idArticolo: number,
  oraIni: number,
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "GetResiduoPostoPrenotazione?dataPren=" + dataPren + '&idArticolo=' + idArticolo.toString() + '&oraIni=' + oraIni.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Fidelity Obiettivi

export const getListFidelityObiettivi = async (
  authToken: string,
  filtro: string,
): Promise<IF.GenericListResponse<IF.FidelityObiettivi>> =>
  fetch(getURLServer() + "GetListFidelityObiettivi?filtro=" + filtro, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateFidelityObiettivo = async (
  authToken: string,
  fidelityObiettivo: IF.FidelityObiettivi
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateFidelityObiettivo", UT.genericPOSTRequest(authToken, { fidelityObiettivo }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteFidelityObiettivo = async (
  authToken: string,
  idFidelityObiettivo: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteFidelityObiettivo", UT.genericPOSTRequest(authToken, { idFidelityObiettivo }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Fidelity Clienti

export const getFidelityCliente = async (
  authToken: string,
  idCliente: number,
): Promise<IF.GenericListResponse<IF.FidelityClienti>> =>
  fetch(getURLServer() + "GetFidelityCliente?idCliente=" + idCliente, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateFidelityCliente = async (
  authToken: string,
  fidelityCliente: IF.FidelityClienti
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateFidelityCliente", UT.genericPOSTRequest(authToken, { fidelityCliente }))
    .then((response) => response.json())
    .then((data) => data);

export const reSendEMailFidelityCliente = async (
  authToken: string,
  idCliente: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "ReSendEMailFidelityCliente", UT.genericPOSTRequest(authToken, { idCliente }))
    .then((response) => response.json())
    .then((data) => data);

export const sendEMailStatusFidelityCliente = async (
  authToken: string,
  idCliente: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "SendEMailStatusFidelityCliente", UT.genericPOSTRequest(authToken, { idCliente }))
    .then((response) => response.json())
    .then((data) => data);

export const getListaFidelityLogs = async (
  authToken: string,
  idCliente: number,
  filtroDataDa: string,
  filtroDataA: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.FidelityLogs>> =>
  fetch(getURLServer() + "GetListFidelityLogs?idCliente=" + idCliente + '&filtroDataDa=' + filtroDataDa + '&filtroDataA=' + filtroDataA + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getClienteByFidelityCode = async (
  authToken: string,
  fidelityCode: string,
): Promise<IF.GenericListResponse<IF.Cliente>> =>
  fetch(getURLServer() + "GetClienteByFidelityCode?fidelityCode=" + fidelityCode, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateFidelityLog = async (
  authToken: string,
  fidelityLog: IF.FidelityLogs
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateFidelityLog", UT.genericPOSTRequest(authToken, { fidelityLog }))
    .then((response) => response.json())
    .then((data) => data);

export const resetFidelityLog = async (
  authToken: string,
  idCliente: number,
  dataFineVecchia: string,
  giorniMargine: number,
  dataInizioNuova: string,
  siglaCampagnaVecchiaMail: string,
  siglaCampagnaNuovaMail: string
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "ResetFidelityLog", UT.genericPOSTRequest(authToken, setBodyReq({ idCliente, dataFineVecchia, giorniMargine, dataInizioNuova, siglaCampagnaVecchiaMail, siglaCampagnaNuovaMail })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Ambulatori

export const GetListaTipoSpesaTS = async (
  authToken: string,
  filtro: string,
): Promise<IF.GenericListResponse<IF.TipoSpesaTessaraSan>> =>
  fetch(getURLServer() + "GetListTipoSpesaTS?filtro=" + filtro, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getListaAmbulatori = async (
  authToken: string,
  filtro: string,
  immagini: number,
  idAmbulatorio: number
): Promise<IF.GenericListResponse<IF.Ambulatorio>> =>
  fetch(getURLServer() + "GetListAmbulatori?filtro=" + filtro + '&immagini=' + immagini.toString() + '&idAmbulatorio=' + idAmbulatorio.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateAmbulatorio = async (
  authToken: string,
  ambulatorio: IF.Ambulatorio
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateAmbulatorio", UT.genericPOSTRequest(authToken, { ambulatorio }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteAmbulatorio = async (
  authToken: string,
  idAmbulatorio: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteAmbulatorio", UT.genericPOSTRequest(authToken, { idAmbulatorio }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Medici

export const getListaMedici = async (
  authToken: string,
  filtro: string,
  immagini: number,
  idMedico: number
): Promise<IF.GenericListResponse<IF.Medico>> =>
  fetch(getURLServer() + "GetListMedici?filtro=" + filtro + '&immagini=' + immagini.toString() + '&idMedico=' + idMedico.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateMedico = async (
  authToken: string,
  medico: IF.Medico
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateMedico", UT.genericPOSTRequest(authToken, { medico }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteMedico = async (
  authToken: string,
  idMedico: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteMedico", UT.genericPOSTRequest(authToken, { idMedico }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Prestazioni

export const getListaPrestazioni = async (
  authToken: string,
  filtro: string,
  idAmbulatorio: number,
  idMedico: number,
  immagini: number,
  idPrestazione: number
): Promise<IF.GenericListResponse<IF.Prestazione>> =>
  fetch(getURLServer() + "GetListPrestazioni?filtro=" + filtro + '&idAmbulatorio=' + idAmbulatorio.toString() + '&idMedico=' + idMedico.toString() + '&immagini=' + immagini.toString() + '&idPrestazione=' + idPrestazione.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updatePrestazione = async (
  authToken: string,
  prestazione: IF.Prestazione
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdatePrestazione", UT.genericPOSTRequest(authToken, { prestazione }))
    .then((response) => response.json())
    .then((data) => data);

export const deletePrestazione = async (
  authToken: string,
  idPrestazione: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeletePrestazione", UT.genericPOSTRequest(authToken, { idPrestazione }))
    .then((response) => response.json())
    .then((data) => data);

export const switchPrestazione = async (
  authToken: string,
  idPrest: number,
  idPrest2: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "SwitchPrestazione", UT.genericPOSTRequest(authToken, setBodyReq({ idPrest, idPrest2 })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Calendari prenotazioni

export const getListaCalendPrenotaz = async (
  authToken: string,
  idMedico: number,
  idPrenotaz: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.CalendPrenotaz>> =>
  fetch(getURLServer() + "GetListCalendPrenotaz?idMedico=" + idMedico.toString() + '&idPrenotaz=' + idPrenotaz.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCalendPrenotaz = async (
  authToken: string,
  calendPrenotaz: IF.CalendPrenotaz
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCalendPrenotaz", UT.genericPOSTRequest(authToken, { calendPrenotaz }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteCalendPrenotaz = async (
  authToken: string,
  idCalendPrenotaz: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteCalendPrenotaz", UT.genericPOSTRequest(authToken, { idCalendPrenotaz }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Prenotazioni prestazioni

export const getPrenotazPrestazDaCod = async (
  authToken: string,
  codPren: string,
): Promise<IF.GenericListResponse<IF.PrenotazPrestaz>> =>
  fetch(getURLServer() + "GetPrenotazPrestazDaCod?codPren=" + codPren, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getPrenotazPrestaz = async (
  authToken: string,
  idPrenotazPrestaz: number,
): Promise<IF.GenericListResponse<IF.PrenotazPrestaz>> =>
  fetch(getURLServer() + "GetPrenotazPrestaz?idPrenotazPrestaz=" + idPrenotazPrestaz.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getListPrenotazPrestaz = async (
  authToken: string,
  dataPren: string,
  dataEsatta: number,
  idCliente: number,
  idPrestazione: number,
  idMedico: number,
  ordinamento: IF.OrdinPren,
  verso: number,
  dataDa: string,
  dataA: string,
): Promise<IF.GenericListResponse<IF.PrenotazPrestaz>> =>
  fetch(getURLServer() + "GetListPrenotazPrestaz?dataPren=" + dataPren + "&dataEsatta=" + dataEsatta.toString() + "&idCliente=" + idCliente.toString() + "&idPrestazione=" + idPrestazione.toString() + "&idMedico=" + idMedico.toString() + "&ordinamento=" + ordinamento.toString() + "&verso=" + verso.toString() + "&dataDa=" + dataDa + "&dataA=" + dataA, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updatePrenotazPrestaz = async (
  authToken: string,
  prenotazPrestaz: IF.PrenotazPrestaz,
  qtaGestFascia: number,
  fasciaManuale: boolean,
  orariSito: number,
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "UpdatePrenotazPrestaz", UT.genericPOSTRequest(authToken, setBodyReq({ prenotazPrestaz, qtaGestFascia, fasciaManuale, orariSito })))
    .then((response) => response.json())
    .then((data) => data);

export const deletePrenotazPrestaz = async (
  authToken: string,
  idPrenotazPrestaz: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeletePrenotazPrestaz", UT.genericPOSTRequest(authToken, { idPrenotazPrestaz }))
    .then((response) => response.json())
    .then((data) => data);

export const getPrestazFasceOrarie = async (
  authToken: string,
  idPrestazione: number,
): Promise<IF.GenericListResponse<IF.FasciaOrariaPrestazione>> =>
  fetch(getURLServer() + "GetPrestazFasceOrarie?idPrestazione=" + idPrestazione.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getResiduoPostoPrenotazPrestaz = async (
  authToken: string,
  dataPren: string,
  idPrestazione: number,
  oraIni: number,
): Promise<IF.GenericResponseData<number>> =>
  fetch(getURLServer() + "GetResiduoPostoPrenotazPrestaz?dataPren=" + dataPren + '&idPrestazione=' + idPrestazione.toString() + '&oraIni=' + oraIni.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getQtaPrenotazPrestaz = async (
  authToken: string,
  dataDa: string,
  dataA: string,
  idPrestaz: number,
  idMedico: number
): Promise<IF.GenericListResponse<{ DataPren: string; Numero: number }>> =>
  fetch(getURLServer() + "GetQtaPrenotazPrestaz?dataDa=" + dataDa + '&dataA=' + dataA + '&idPrestaz=' + idPrestaz.toString() + '&idMedico=' + idMedico.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getPrenotazPrestazOrari = async (
  authToken: string,
  dataPren: string,
  idPrestaz: number,
): Promise<IF.GenericListResponse<IF.OrariPrenoResult>> =>
  fetch(getURLServer() + "GetPrenotazPrestazOrari?dataPren=" + dataPren + '&idPrestaz=' + idPrestaz, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Impostazioni Prenotazioni prestazioni

export const getImpostazPrenotazPrestaz = async (
  authToken: string,
): Promise<IF.GenericResponseData<IF.ImpostazPrenotazPrestaz>> =>
  fetch(getURLServer() + "GetImpostazPrenotazPrestaz", UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateImpostazPrenotazPrestaz = async (
  authToken: string,
  impostazPP: IF.ImpostazPrenotazPrestaz,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateImpostazPrenotazPrestaz", UT.genericPOSTRequest(authToken, { impostazPP }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Note Agenda

export const getListaNotePrenotazAgenda = async (
  authToken: string,
  filtroData: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.NotaPrenotazAgenda>> =>
  fetch(getURLServer() + "GetListNotePrenotazAgenda?filtroData=" + filtroData + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateNotaPrenotazAgenda = async (
  authToken: string,
  notaPA: IF.NotaPrenotazAgenda
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateNotaPrenotazAgenda", UT.genericPOSTRequest(authToken, { notaPA }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteNotaPrenotazAgenda = async (
  authToken: string,
  idNotaPA: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteNotaPrenotazAgenda", UT.genericPOSTRequest(authToken, { idNotaPA }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region POS

export const getImpostazioniPOS = async (
  authToken: string,
): Promise<IF.GenericResponseData<IF.ImpostazioniPOS>> =>
  fetch(getURLServer() + "GetImpostazioniPOS", UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateImpostazioniPOS = async (
  authToken: string,
  impostazPos: IF.ImpostazioniPOS,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateImpostazioniPOS", UT.genericPOSTRequest(authToken, { impostazPos }))
    .then((response) => response.json())
    .then((data) => data);

export const getPredefinitiPOS = async (
  authToken: string,
): Promise<IF.GenericResponseData<IF.PredefinitiPos>> =>
  fetch(getURLServer() + "GetPredefinitiPOS", UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const addPredefinitiPOS = async (
  authToken: string,
  idArt: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "AddPredefinitiPOS", UT.genericPOSTRequest(authToken, { idArt }))
    .then((response) => response.json())
    .then((data) => data);

export const removePredefinitiPOS = async (
  authToken: string,
  idArt: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "RemovePredefinitiPOS", UT.genericPOSTRequest(authToken, { idArt }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Scontrini

export const getListTipoAutofattura = async (
  authToken: string,
  filtro: string,
): Promise<IF.GenericListResponse<IF.TipoAutofattura>> =>
  fetch(getURLServer() + "GetListTipoAutofattura?filtro=" + filtro, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getListaScontrini = async (
  authToken: string,
  idOperatore: number,
  matricolaStamp: string,
  filtroDataDa: string,
  filtroDataA: string,
  tipoScontrino: number,
  filtroCliente: number,
  filtroInviataTS: number,
  pageNumber: number,
  itemsPerPage: number,
  idScontrino: number,
  calcTotale: number,
): Promise<IF.GenericListResponse<IF.ScontrinoTestata>> =>
  fetch(getURLServer() + "GetListScontrini?idOperatore=" + idOperatore + '&matricolaStamp=' + matricolaStamp + '&filtroDataDa=' + filtroDataDa + '&filtroDataA=' + filtroDataA + '&tipoScontrino=' + tipoScontrino.toString() + '&filtroCliente=' + filtroCliente.toString() + '&filtroInviataTS=' + filtroInviataTS.toString() + '&calcTotale=' + calcTotale.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString() + '&idScontrino=' + idScontrino.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getListaScontrinoRighe = async (
  authToken: string,
  idScontrino: number,
): Promise<IF.GenericListResponse<IF.ScontrinoRiga>> =>
  fetch(getURLServer() + "GetListScontrinoRighe?idScontrino=" + idScontrino, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const insertScontrino = async (
  authToken: string,
  scontrino: IF.Scontrino
): Promise<IF.GenericResponseData<{ idSc: number; numeroSc: number; }>> =>
  fetch(getURLServer() + "InsertScontrino", UT.genericPOSTRequest(authToken, { scontrino }))
    .then((response) => response.json())
    .then((data) => data);

export const allineaASistemaTS = async (
  authToken: string,
  idScontrino: number,
  azione: "ADD" | "MOD" | "DEL",
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "AllineaASistemaTS", UT.genericPOSTRequest(authToken, setBodyReq({ idScontrino, azione })))
    .then((response) => response.json())
    .then((data) => data);

export const stornaScontrino = async (
  authToken: string,
  idScontrino: number,
  elimina: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "StornaScontrino", UT.genericPOSTRequest(authToken, setBodyReq({ idScontrino, elimina })))
    .then((response) => response.json())
    .then((data) => data);

export const setFisPrinterNrScontrino = async (
  authToken: string,
  idScontrino: number,
  numFisPri: number,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "SetFisPrinterNrScontrino", UT.genericPOSTRequest(authToken, setBodyReq({ idScontrino, numFisPri })))
    .then((response) => response.json())
    .then((data) => data);

export const getListaScontriniExport = async (
  authToken: string,
  tipoScontrino: number,
  idOperatore: number,
  matricolaStamp: string,
  filtroDataDa: string,
  filtroDataA: string,
  filtroCliente: number,
  filtroInviataTS: number,
  calcTotale: number
): Promise<IF.GenericListResponse<IF.ScontrinoTestata>> =>
  fetch(getURLServer() + "GetListScontriniExport?tipoScontrino=" + tipoScontrino + "&idOperatore=" + idOperatore + '&matricolaStamp=' + matricolaStamp + '&filtroDataDa=' + filtroDataDa + '&filtroDataA=' + filtroDataA + '&filtroCliente=' + filtroCliente.toString() + '&filtroInviataTS=' + filtroInviataTS.toString() + '&calcTotale=' + calcTotale.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getReportScontrini = async (
  authToken: string,
  idOperatore: number,
  matricolaStamp: string,
  tipoScontrino: number,
  filtroDataDa: string,
  filtroDataA: string,
  filtroCliente: number,
  filtroInviataTS: number,
): Promise<IF.GenericListResponse<IF.ReportScontrini>> =>
  fetch(getURLServer() + "GetReportScontrini?idOperatore=" + idOperatore.toString() + '&matricolaStamp=' + matricolaStamp + '&tipoScontrino=' + tipoScontrino.toString() + '&filtroDataDa=' + filtroDataDa + '&filtroDataA=' + filtroDataA + '&filtroCliente=' + filtroCliente.toString() + '&filtroInviataTS=' + filtroInviataTS.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const getPDFScontrino = async (
  authToken: string,
  idScontrino: number,
): Promise<IF.GenericResponseData<string>> =>
  fetch(getURLServer() + "GetPDFScontrino?idScontrino=" + idScontrino.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Sconti POS

export const getListaScontiPOS = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.ScontoPOS>> =>
  fetch(getURLServer() + "GetListScontiPOS?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateScontoPOS = async (
  authToken: string,
  scontoPOS: IF.ScontoPOS
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateScontoPOS", UT.genericPOSTRequest(authToken, { scontoPOS }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteScontoPOS = async (
  authToken: string,
  idScontoPOS: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteScontoPOS", UT.genericPOSTRequest(authToken, { idScontoPOS }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Categorie agende generiche

export const getListaCategAgendaGen = async (
  authToken: string,
  filtro: string,
  idOperatore: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.CategoriaAgenda>> =>
  fetch(getURLServer() + "GetListCategAgendaGen?filtro=" + filtro + '&idOperatore=' + idOperatore + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCategAgendaGen = async (
  authToken: string,
  categAgendaGen: IF.CategoriaAgenda
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCategAgendaGen", UT.genericPOSTRequest(authToken, { categAgendaGen }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteCategAgendaGen = async (
  authToken: string,
  idCategAgendaGen: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteCategAgendaGen", UT.genericPOSTRequest(authToken, { idCategAgendaGen }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Agende generiche

export const getListaAgendaGenerica = async (
  authToken: string,
  filtro: string,
  idOperatore: number,
  dataDa: string,
  dataA: string,
  eleCat: string,
  eleOpe: string,
  visEventi: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.AgendaGenerica>> =>
  fetch(getURLServer() + "GetListAgendaGenerica?filtro=" + filtro + '&idOperatore=' + idOperatore + '&dataDa=' + dataDa + '&dataA=' + dataA + '&eleCat=' + eleCat + '&eleOpe=' + eleOpe + '&visEventi=' + visEventi + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateAgendaGenerica = async (
  authToken: string,
  agendaGen: IF.AgendaGenerica
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateAgendaGenerica", UT.genericPOSTRequest(authToken, { agendaGen }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteAgendaGenerica = async (
  authToken: string,
  idAgendaGen: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteAgendaGenerica", UT.genericPOSTRequest(authToken, { idAgendaGen }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Bacheche compiti

export const getListaBachecheCompiti = async (
  authToken: string,
  filtro: string,
  idOperatore: number,
  archiviata: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.BachecaCompiti>> =>
  fetch(getURLServer() + "GetListBachecheCompiti?filtro=" + filtro + '&idOperatore=' + idOperatore + '&archiviata=' + archiviata + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateBachecaCompiti = async (
  authToken: string,
  bachecaCompiti: IF.BachecaCompiti
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateBachecaCompiti", UT.genericPOSTRequest(authToken, { bachecaCompiti }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteBachecaCompiti = async (
  authToken: string,
  idBachecaCompiti: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteBachecaCompiti", UT.genericPOSTRequest(authToken, { idBachecaCompiti }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Compiti

export const getListaCompiti = async (
  authToken: string,
  filtro: string,
  idOperatore: number,
  idBacheca: number,
  numEtic: number,
  filtroOper: number,
  filtroCli: number,
  stato: number,
  priorita: number,
  ordinamento: number,
  sortDir: "ascending" | "descending",
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.Compito>> =>
  fetch(getURLServer() + "GetListCompiti?filtro=" + filtro + '&idOperatore=' + idOperatore + '&idBacheca=' + idBacheca + '&numEtic=' + numEtic + '&filtroOper=' + filtroOper + '&filtroCli=' + filtroCli + '&stato=' + stato + '&priorita=' + priorita + '&ordinamento=' + ordinamento + '&sortDir=' + sortDir + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCompito = async (
  authToken: string,
  compito: IF.Compito
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCompito", UT.genericPOSTRequest(authToken, { compito }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteCompito = async (
  authToken: string,
  idCompito: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteCompito", UT.genericPOSTRequest(authToken, { idCompito }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Allegati compiti

export const getListaAllegatiCompito = async (
  authToken: string,
  idCompito: number,
): Promise<IF.GenericListResponse<IF.AllegatoCompito>> =>
  fetch(getURLServer() + "GetListAllegatiCompito?idCompito=" + idCompito, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateAllegatoCompito = async (
  authToken: string,
  allegato: IF.AllegatoCompito
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateAllegatoCompito", UT.genericPOSTRequest(authToken, { allegato }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteAllegatoCompito = async (
  authToken: string,
  idCompito: number,
  idAllegato: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteAllegatoCompito", UT.genericPOSTRequest(authToken, setBodyReq({ idCompito, idAllegato })))
    .then((response) => response.json())
    .then((data) => data);

export const getNewPushNotificationCompiti = async (
  authToken: string,
  idOperatore: number,
): Promise<IF.GenericListResponse<IF.CompitoNotifiche>> =>
  fetch(getURLServer() + "GetNewPushNotificationCompiti?idOperatore=" + idOperatore, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const SetReadPushNotificationCompiti = async (
  authToken: string,
  idCompito: number,
  idOperatore: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "SetReadPushNotificationCompiti", UT.genericPOSTRequest(authToken, setBodyReq({ idCompito, idOperatore })))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region SmsEmailCRM

export const getListaSmsEmailCRM = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.SmsEmailCRM>> =>
  fetch(getURLServer() + "GetListSmsEmailCRM?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateSmsEmailCRM = async (
  authToken: string,
  smsEmail: IF.SmsEmailCRM,
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateSmsEmailCRM", UT.genericPOSTRequest(authToken, setBodyReq({ smsEmail, 'tokenSms': authToken })))
    .then((response) => response.json())
    .then((data) => data);

export const deleteSmsEmailCRM = async (
  authToken: string,
  idSmsEmail: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteSmsEmailCRM", UT.genericPOSTRequest(authToken, { idSmsEmail }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Aree

export const getListaAree = async (
  authToken: string,
  filtro: string,
  idArea: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.Area>> =>
  fetch(getURLServer() + "GetListAree?filtro=" + filtro + '&idArea=' + idArea + '&itemsPerPage=' + pageNumber + '&itemsPerPage=' + itemsPerPage, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateArea = async (
  authToken: string,
  area: IF.Area
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateArea", UT.genericPOSTRequest(authToken, { area }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteArea = async (
  authToken: string,
  idArea: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteArea", UT.genericPOSTRequest(authToken, { idArea }))
    .then((response) => response.json())
    .then((data) => data);

export const updateTavolo = async (
  authToken: string,
  tavolo: IF.Tavolo
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateTavolo", UT.genericPOSTRequest(authToken, { tavolo }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Esercenti

export const getListaEsercenti = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
  immagini: number,
  idEsercente: number,
): Promise<IF.GenericListResponse<IF.Esercente>> =>
  fetch(getURLServer() + "GetListEsercenti?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&immagini=' + immagini + '&idEsercente=' + idEsercente, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateEsercente = async (
  authToken: string,
  esercente: IF.Esercente
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateEsercente", UT.genericPOSTRequest(authToken, { esercente }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteEsercente = async (
  authToken: string,
  idEsercente: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteEsercente", UT.genericPOSTRequest(authToken, { idEsercente }))
    .then((response) => response.json())
    .then((data) => data);

export const loginEsercente = async (
  authToken: string,
  username: string,
  password: string
): Promise<IF.GenericResponseData<IF.Esercente>> =>
  fetch(getURLServer() + "LoginEsercente", UT.genericPOSTRequest(authToken, { username, password }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Sedi esercenti

export const getListaSediEsercenti = async (
  authToken: string,
  filtro: string,
  idEsercente: number,
  pageNumber: number,
  itemsPerPage: number,
  immagini: number,
  idSedeEserc: number,
): Promise<IF.GenericListResponse<IF.SedeEsercente>> =>
  fetch(getURLServer() + "GetListSediEsercenti?filtro=" + filtro + '&idEsercente=' + idEsercente + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&immagini=' + immagini + '&idSedeEserc=' + idSedeEserc, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateSedeEsercente = async (
  authToken: string,
  sedeEserc: IF.SedeEsercente
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateSedeEsercente", UT.genericPOSTRequest(authToken, { sedeEserc }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteSedeEsercente = async (
  authToken: string,
  idSedeEserc: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteSedeEsercente", UT.genericPOSTRequest(authToken, { idSedeEserc }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Totem esercenti

export const getDatiTotem = async (
  authToken: string,
  idSedeEserc: number,
): Promise<IF.GenericResponseData<IF.DatiTotem>> =>
  fetch(getURLServer() + "GetDatiTotem?idSedeEserc=" + idSedeEserc, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateDatiTotem = async (
  authToken: string,
  idSedeEserc: number,
  datiTotem: IF.DatiTotem
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateDatiTotem", UT.genericPOSTRequest(authToken, { datiTotem, idSedeEserc }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteDatiTotem = async (
  authToken: string,
  idSedeEserc: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteDatiTotem", UT.genericPOSTRequest(authToken, { idSedeEserc }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Segmenti Veicoli

export const getListaVeiSegmenti = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
  idSegmento: number,
): Promise<IF.GenericListResponse<IF.VeiSegmento>> =>
  fetch(getURLServer() + "GetListVeiSegmenti?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&idSegmento=' + idSegmento, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateVeiSegmento = async (
  authToken: string,
  segmento: IF.VeiSegmento
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateVeiSegmento", UT.genericPOSTRequest(authToken, { segmento }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteVeiSegmento = async (
  authToken: string,
  idSegmento: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteVeiSegmento", UT.genericPOSTRequest(authToken, { idSegmento }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Segmenti Veicoli Sedi

export const getListaVeiSegmentiSedi = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
  idSegmento: number,
  idSedeEserc: number
): Promise<IF.GenericListResponse<IF.VeiSegmentiRicarSediEserc>> =>
  fetch(getURLServer() + "GetListVeiSegmentiSedi?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&idSegmento=' + idSegmento + '&idSedeEserc=' + idSedeEserc, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateVeiSegmentoSede = async (
  authToken: string,
  segmentoSede: IF.VeiSegmentiRicarSediEserc
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateVeiSegmentoSede", UT.genericPOSTRequest(authToken, { segmentoSede }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteVeiSegmentoSede = async (
  authToken: string,
  idSegmento: number,
  idSedeEserc: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteVeiSegmentoSede", UT.genericPOSTRequest(authToken, { idSegmento, idSedeEserc }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Costruttori Veicoli

export const getListaVeiCostruttori = async (
  authToken: string,
  filtro: string,
  pageNumber: number,
  itemsPerPage: number,
  idCostruttore: number,
): Promise<IF.GenericListResponse<IF.VeiCostruttore>> =>
  fetch(getURLServer() + "GetListVeiCostruttori?filtro=" + filtro + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&idCostruttore=' + idCostruttore, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateVeiCostruttore = async (
  authToken: string,
  costruttore: IF.VeiCostruttore
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateVeiCostruttore", UT.genericPOSTRequest(authToken, { costruttore }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteVeiCostruttore = async (
  authToken: string,
  idCostruttore: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteVeiCostruttore", UT.genericPOSTRequest(authToken, { idCostruttore }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Modello Veicoli

export const getListaVeiModelli = async (
  authToken: string,
  filtro: string,
  filtroCostr: number,
  pageNumber: number,
  itemsPerPage: number,
  idModello: number,
): Promise<IF.GenericListResponse<IF.VeiModello>> =>
  fetch(getURLServer() + "GetListVeiModelli?filtro=" + filtro + '&filtroCostr=' + filtroCostr + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&idModello=' + idModello, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateVeiModello = async (
  authToken: string,
  modello: IF.VeiModello
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateVeiModello", UT.genericPOSTRequest(authToken, { modello }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteVeiModello = async (
  authToken: string,
  idModello: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteVeiModello", UT.genericPOSTRequest(authToken, { idModello }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Veicoli

export const getListaVeicoli = async (
  authToken: string,
  filtro: string,
  filtroCli: number,
  filtroSeg: number,
  pageNumber: number,
  itemsPerPage: number,
  idVeicolo: number,
  foto: number
): Promise<IF.GenericListResponse<IF.Veicolo>> =>
  fetch(getURLServer() + "GetListVeicoli?filtro=" + filtro + '&filtroCli=' + filtroCli + '&filtroSeg=' + filtroSeg + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&idVeicolo=' + idVeicolo + '&foto=' + foto, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateVeicolo = async (
  authToken: string,
  veicolo: IF.Veicolo
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateVeicolo", UT.genericPOSTRequest(authToken, { veicolo }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteVeicolo = async (
  authToken: string,
  idVeicolo: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteVeicolo", UT.genericPOSTRequest(authToken, { idVeicolo }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Crediti Clienti

export const getCreditoCliente = async (
  authToken: string,
  idCliente: number,
): Promise<IF.GenericListResponse<IF.TransazClientiCrediti>> =>
  fetch(getURLServer() + "GetCreditoCliente?idCliente=" + idCliente, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const caricaCreditoCliente = async (
  authToken: string,
  idCliente: number,
  numCrediti: number
): Promise<IF.GenericResponseData<string>> =>
  fetch(getURLServer() + "CaricaCreditoCliente", UT.genericPOSTRequest(authToken, { idCliente, numCrediti }))
    .then((response) => response.json())
    .then((data) => data);

export const updateCreditoCliente = async (
  authToken: string,
  credito: IF.TransazClientiCrediti
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCreditoCliente", UT.genericPOSTRequest(authToken, { credito }))
    .then((response) => response.json())
    .then((data) => data);

export const updateCreditoClienteFromOTP = async (
  authToken: string,
  idCliente: number,
  numCrediti: number,
  idSedeEserc: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCreditoClienteFromOTP", UT.genericPOSTRequest(authToken, { idCliente, numCrediti, idSedeEserc }))
    .then((response) => response.json())
    .then((data) => data);

export const getListaCreditiLogs = async (
  authToken: string,
  idCliente: number,
  filtroDataDa: string,
  filtroDataA: string,
  idSedeEserc: number,
  pageNumber: number,
  itemsPerPage: number,
): Promise<IF.GenericListResponse<IF.TransazClientiLogs>> =>
  fetch(getURLServer() + "GetListCreditiLogs?idCliente=" + idCliente + '&filtroDataDa=' + filtroDataDa + '&filtroDataA=' + filtroDataA + '&idSedeEserc=' + idSedeEserc.toString() + '&pageNumber=' + pageNumber.toString() + '&itemsPerPage=' + itemsPerPage.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateCreditoLog = async (
  authToken: string,
  creditoLog: IF.TransazClientiLogs
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateCreditoLog", UT.genericPOSTRequest(authToken, { creditoLog }))
    .then((response) => response.json())
    .then((data) => data);

export const getOTPCodeCreditoCliente = async (
  authToken: string,
  idCliente: number,
  numCrediti: number
): Promise<IF.GenericResponseData<string>> =>
  fetch(getURLServer() + "GetOTPCodeCreditoCliente?idCliente=" + idCliente.toString() + '&numCrediti=' + numCrediti.toString(), UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

//#endregion

//#region Recensioni

export const getListaRecensioni = async (
  authToken: string,
  filtro: string,
  idCliente: number,
  idSedeEserc: number,
  pageNumber: number,
  itemsPerPage: number,
  idRecensione: number,
): Promise<IF.GenericListResponse<IF.RecensioniClienti>> =>
  fetch(getURLServer() + "GetListRecensioni?filtro=" + filtro + '&idCliente=' + idCliente + '&idSedeEserc=' + idSedeEserc + '&pageNumber=' + pageNumber + '&itemsPerPage=' + itemsPerPage + '&idRecensione=' + idRecensione, UT.genericGETRequest(authToken))
    .then((response) => response.json())
    .then((data) => data);

export const updateRecensione = async (
  authToken: string,
  recensione: IF.RecensioniClienti
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "UpdateRecensione", UT.genericPOSTRequest(authToken, { recensione }))
    .then((response) => response.json())
    .then((data) => data);

export const deleteRecensione = async (
  authToken: string,
  idRecensione: number
): Promise<IF.GenericResponse> =>
  fetch(getURLServer() + "DeleteRecensione", UT.genericPOSTRequest(authToken, { idRecensione }))
    .then((response) => response.json())
    .then((data) => data);

//#endregion
